'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants } from '@/components/ui/button'
import SwiperCarousel from '@/components/ui/carousel'
import { SvgArrowUpRight } from '@/components/ui/icons'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'

const Applications = () => {
  const { session } = useAuth()
  return (
    <FadeInStagger
      faster
      className="pt-24 w-full max-w-7xl px-6 lg:px-8 mx-auto"
    >
      <div className="w-full justify-between md:items-end gap-5 flex-col md:flex-row inline-flex ">
        <div className="w-full  flex-col justify-start items-start gap-5 inline-flex ">
          <div className="self-stretch flex-col justify-start items-start gap-3 flex">
            <FadeIn className="p-1 bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
              <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                <div className="text-center text-white text-sm font-medium leading-[20px]">
                  Join the movement
                </div>
              </div>
            </FadeIn>
            <FadeIn className="self-stretch text-white text-[40px] font-semibold leading-[44px]">
              Our Alumni
            </FadeIn>
          </div>
          <div className="w-full flex flex-col sm:flex-row gap-2 justify-between sm:items-center">
            <FadeIn className="text-white text-xl font-normal leading-[30px]">
              We welcome applicants from the following backgrounds:
            </FadeIn>
            <FadeIn>
              <Link
                href={`${getApplyRedirectUrl(session)}`}
                className={cn(
                  buttonVariants({ variant: 'outline', size: 'lg' }),
                  'text-base',
                )}
              >
                Apply Now <SvgArrowUpRight className=" w-5 h-5" />
              </Link>
            </FadeIn>
          </div>
        </div>
      </div>
      <FadeIn>
        <SwiperCarousel />
      </FadeIn>
    </FadeInStagger>
  )
}
export default Applications
